import { toast } from "sonner";

/** VIB-2530: lenge nok til å rekke å lese og klikke Angre, kort nok til å ikke stable seg. */
export const UNDO_TOAST_DURATION_MS = 8000;

/**
 * Suksess-toast med «Angre»-handling. Brukes der ett klikk skriver rett til
 * databasen uten dialog (RBAC-matrisene, funksjonsbrytere). `onUndo` skal
 * kalle samme mutasjon med forrige verdi — angre er en ny skriving som også
 * havner i audit-loggen, ikke en sletting av den første.
 */
export function showUndoToast(message: string, onUndo: () => void): string | number {
  return toast.success(message, {
    duration: UNDO_TOAST_DURATION_MS,
    action: { label: "Angre", onClick: onUndo },
  });
}
